<template>
    <table class="table no-border">
        <tr v-if="selectable" class="bb-1 selectable-line">
            <td
                v-for="(column, indexColumn) in lines[0]"
                :key="indexColumn"
                class="br-1"
                :class="{ 'primary-05-bkg': isSelected(indexColumn) }"
            >
                <a class="link semibold" @click="selectColumn(indexColumn)">
                    {{ $l10n.__('Sélectionner') }}
                </a>
            </td>
        </tr>
        <tr v-for="(line, index) in lines" :key="index" class="bb-1">
            <td
                v-for="(column, indexColumn) in getFilteredLine(line)"
                :key="indexColumn"
                class="br-1 mw-96"
                :class="[
                    { 'primary-05-bkg': isSelected(indexColumn) },
                    { error: hasError(indexColumn, line) },
                ]"
            >
                {{ hasError(indexColumn, line) ? line.errors[indexColumn] : column }}
            </td>
        </tr>
    </table>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Array,
            required: false,
            default: () => [],
        },
        lines: {
            type: Array,
            required: true,
        },
        max: {
            type: [Number, Boolean],
            required: false,
            default: false,
        },
        selectable: {
            type: Boolean,
            required: false,
            default: true,
        },
        format: {
            type: String,
            required: false,
            default: 'array',
            validator(val) {
                return ['array', 'object'].includes(val);
            },
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {};
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        selectColumn(index) {
            if (this.isSelected(index)) {
                this.value.splice(
                    this.value.findIndex((valueIndex) => valueIndex == index),
                    1,
                );
            } else {
                if (this.max && this.value.length < this.max) {
                    this.value.push(index);
                } else {
                    if (this.max === 1) {
                        this.$emit('update:modelValue', [index]);
                    } else {
                        Push.error(
                            this.$l10n.__(
                                'Vous ne pouvez pas sélectionner plus de %(nb)s colonnes',
                                { nb: this.max },
                            ),
                            false,
                        );
                    }
                }
            }
        },
        isSelected(index) {
            return this.value.includes(index);
        },
        hasError(index, line) {
            return line.errors && line.errors[index];
        },
        getFilteredLine(line) {
            const arrayLine = Array.isArray(line)
                ? line
                : Object.keys(line).map((key) => line[key]);
            return arrayLine.map((column, index) => {
                if (index === 'errors') {
                    return;
                }
                return column;
            });
        },
    },
};
</script>

<style scoped>
.error {
    background-color: #f67d8c !important;
    color: white;
}
.selectable-line {
    height: 48px;
}
</style>
